import { get, post, type RequestConfig } from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

export interface TiffinSevaDonation {
  id: number;
  donor_name: string;
  email: string;
  mobile_number: string;
  amount: string;
  payment_mode?: string;
  payment_reference?: string;
  status: string;
  created_at?: string;
  updated_at?: string;
  scheme_name?: string | null;
  occasion?: string | null;
}

export interface TiffinSevaAddDonationPayload {
  scheme: number;
  times: number;
  donor_name: string;
  mobile_number: string;
  email: string;
  city: string;
  full_address: string;
  state: string;
  pincode: string;
  country: string;
  occasion?: string;
  display_name?: string;
  special_instructions?: string;
  is_anonymous: boolean;
  info_confirmed: boolean;
  contact_consent: boolean;
  payment_mode: string;
  payment_reference: string;
  mode: string;
}

const BASE = `${JIVANDHARA_BASE}/tiffin-seva-donations`;
const SILENT: RequestConfig = { showNotification: false };

class TiffinSevaDonationService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<TiffinSevaDonation>> =>
    fetchListPage<TiffinSevaDonation>(`${BASE}/`, query);

  get = async (id: number): Promise<TiffinSevaDonation | undefined> => {
    const data = await get<ApiItemResponse<TiffinSevaDonation> | TiffinSevaDonation>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  add = async (
    payload: TiffinSevaAddDonationPayload
  ): Promise<TiffinSevaDonation | undefined> => {
    const data = await post<
      ApiItemResponse<TiffinSevaDonation> | TiffinSevaDonation,
      TiffinSevaAddDonationPayload
    >(`${BASE}/add/`, payload, SILENT);
    return unwrapItem(data);
  };
}

export const tiffinSevaDonationService = new TiffinSevaDonationService();
